import { get } from '@/tools/http';

const perPage = 6;

const IN_LOADING = {};

export default {
    namespaced: true,

    state: {
        contests: {
            pagesCount: 1,
            pages: {},
            ids: [],
        },
        events: {
            pagesCount: 1,
            pages: {},
            ids: [],
        },
        internship: {
            pagesCount: 1,
            pages: {},
            ids: [],
        },
        seasons: [],
        seasonsCached: {},

        currentItem: null,
        seasonType: '',
        hashTag: '',
    },

    mutations: {
        updateHashTag: (state, tag) => state.hashTag = tag,
        setSeasonType: (state, seasonType) => state.seasonType = seasonType,
        addPage: (state, value) => {
            const obj = state[value.type];

            const page = {
                seasons: value.seasons,
                time: Date.now(),
            };

            obj.pagesCount = value.pagesCount;
            obj.pages = { ...obj.pages, [value.curPage]: page };
            obj.ids = obj.ids.concat(value.ids);
        },

        resetItems: (state) => {
            state[state.seasonType] = {
                pagesCount: 1,
                pages: {},
                ids: [],
            };
        },

        writeCurrentItem: (state, value) => state.currentItem = value,

        setSeasons: (state, seasons) => state.seasons = seasons,

        writeCachedSeason: (state, season) => state.seasonsCached[season.id] = season,
    },

    actions: {
        setHashTag: (ctx, { tag }) => {
            ctx.commit('updateHashTag', tag);
            ctx.dispatch('loadSeasons', { page: 1, type: ctx.state.seasonType });
        },
        updateType: (ctx, type) => {
            ctx.commit('setSeasonType', type);
        },
        loadSeasons: async (ctx, {
            type,
            page = 1,
            perPage = 20,
            fetchOnly = false,
            withoutPagination = false,
            withNoPublication = false,
        }) => {
            if (!fetchOnly) {
                ctx.commit('setSeasonType', type);
                ctx.commit('resetItems');
            }
            const offset = page * perPage - perPage;
            const params = { limit: perPage, offset, type };

            if (ctx.state.hashTag && !fetchOnly) {
                params['filter[hashtags][]'] = ctx.state.hashTag;
            }

            if (withNoPublication) {
                params['filter[withNoPublication]'] = 1;
            }

            const res = await get('projects', `api/v1/seasons`, params);

            if (!fetchOnly) {
                const ids = [];

                for(let ses in res.seasons) {
                    if (res.seasons.hasOwnProperty(ses)) {
                        ids.push(res.seasons[ses]['id']);
                    }
                }

                const value = {
                    pagesCount: res.pages,
                    curPage: res.page,
                    seasons: res.seasons,
                    ids: ids,
                    type,
                };

                ctx.commit('addPage', value);
            }

            if (withoutPagination) {
                ctx.commit('setSeasons', res.seasons);
            }

            return res;
        },
        loadAllSeasons: async (ctx) => {
            try {
                const res = await get('projects', `api/v1/seasons/all`);
                ctx.commit('setSeasons', res.seasons);
                return (res || {}).seasons || [];
            } catch(e) {
                console.log(e);
            }

            return null;
        },

        loadSeason: async (ctx, id) => {
            const res = await get('projects', `api/v1/seasons/${id}`);
            if (res) {
                res.id = id;
                ctx.commit('writeCurrentItem', res);
            }

            return res;
        },

        loadSeasonCached: async (ctx, id) => {
            const idx = `season_cached_${id}`;

            if (ctx.state.seasonsCached[id]) {
                return ctx.state.seasonsCached[id];
            }

            if (IN_LOADING[idx]) {
                return await new Promise((resolve) => {
                    const interval = setInterval(async () => {
                        if (IN_LOADING[idx] === -1) {
                            clearInterval(interval);
                            resolve(
                                await ctx.dispatch('loadSeasonCached', id)
                            );
                        } else if (IN_LOADING[idx] === false) {
                            clearInterval(interval);
                            resolve();
                        }
                    }, 100);
                });
            }

            IN_LOADING[idx] = true;

            try {
                const res = await get('projects', `api/v1/seasons/${id}`);

                ctx.commit('writeCachedSeason', {id, ...res});
            } catch (e) {
                IN_LOADING[idx] = -1;
                return await ctx.dispatch('loadSeasonCached', id);
            }

            IN_LOADING[idx] = true;

            return ctx.state.seasonsCached[id];
        },

        clearCurrent: ctx => ctx.commit('writeCurrentItem', null),
    },

    getters: {
        contests: state => state.contests,
        events: state => state.events,
        internship: state => state.internship,

        currentItem: state => state.currentItem,
        getHashTag: state => state.hashTag,

        getSeasons: state => state.seasons,
        getSeasonsCached: state => state.seasonsCached,
    },
};
